import moment from 'moment';
import 'moment/locale/es-mx';

export const adultHasNoPhone = (customer) => {
  const isAdult = moment().isSameOrAfter(
      moment(customer.birthday).add(18, 'years'),
      'day'
    );
  return !!(customer && !customer?.phone && !customer?.mobilePhone && isAdult);
}
